import { Quill } from 'react-quill';

const Link = Quill.import('formats/link');

class MyLink extends Link {
  static create(value) {
    const node = super.create(value);
    // eslint-disable-next-line no-param-reassign
    value = this.sanitize(value);
    node.setAttribute('href', value);
    if (value.startsWith(process.env.REACT_APP_API_URL)) {
      node.removeAttribute('target');
    }
    return node;
  }
}

export default MyLink;



// WEBPACK FOOTER //
// ./src/helpers/quill.helper.js